
<router-outlet></router-outlet>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/app.component.html